import { AST } from '@handlebars/parser';

import { isStringLiteral } from './isStringLiteral';
import { isNumberLiteral } from './isNumberLiteral';
import { isBooleanLiteral } from './isBooleanLiteral';
import { isUndefinedLiteral } from './isUndefinedLiteral';
import { isNullLiteral } from './isNullLiteral';

export const isLiteral = (node: AST.Node): node is AST.Expression =>
  isStringLiteral(node) ||
  isBooleanLiteral(node) ||
  isNumberLiteral(node) ||
  isUndefinedLiteral(node) ||
  isNullLiteral(node);
